import { useQuery } from '@apollo/client';
import React from 'react';
import {
  StaffCaseSearchContainerCaseSearchResultFieldsFragment,
  StaffCaseSearchFilterContainerCaseGetAllTagsDocument,
  StaffCaseSearchFilterContainerEntitiesDocument,
  StaffCaseSearchFilterContainerEntityFieldsFragment,
  StaffCaseSearchFilterContainerStaffUserCurrentDocument,
  StaffCaseSearchFilterContainerStaffUsersDocument,
  StaffCaseSearchFilterContainerStaffUsersFieldsFragment
} from '../../../../generated';
import { useOid } from '../../../../hooks/useOid';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from '../../../shared/utils/queryOptions';
import { CaseSearchFilter } from './case-search-filter';

interface CaseSearchFilterContainerProps {
  filterDataCount: StaffCaseSearchContainerCaseSearchResultFieldsFragment;
  setRefreshQuery: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CaseSearchFilterContainer: React.FC<CaseSearchFilterContainerProps> = (props) => {
  const refreshTagHandler = () => {
    refetchCaseGetAllTags();
    props?.setRefreshQuery(true);
  };

  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);

  const { data: staffUserList, error: staffUserListError, loading: staffUserListLoading } = useQuery(StaffCaseSearchFilterContainerStaffUsersDocument);

  const { data: entitiesList, error: entitiesListError, loading: entitiesListLoading } = useQuery(StaffCaseSearchFilterContainerEntitiesDocument
    , {
      context: {
        headers: {
          "cache-enabled": "true"
        }
      }
    }
  );

  const { data: staffUserData, error: staffUserError, loading: staffUserLoading } = useQuery(StaffCaseSearchFilterContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  const {
    data: caseGetAllTags,
    error: caseGetAllTagsError,
    loading: caseGetAllTagsLoading,
    refetch: refetchCaseGetAllTags
  } = useQuery(StaffCaseSearchFilterContainerCaseGetAllTagsDocument);

  return (
    <div className="min-w-[220px] max-w-[300px]">
      <ComponentQueryLoader
        loading={staffUserListLoading || entitiesListLoading || staffUserLoading || caseGetAllTagsLoading}
        hasData={staffUserData && staffUserList && entitiesList && caseGetAllTags}
        error={staffUserListError || entitiesListError || staffUserError || caseGetAllTagsError}
        hasDataComponent={
          <CaseSearchFilter
            staffUserList={staffUserList?.staffUsers as StaffCaseSearchFilterContainerStaffUsersFieldsFragment[]}
            entitiesList={entitiesList?.entities as StaffCaseSearchFilterContainerEntityFieldsFragment[]}
            data={props?.filterDataCount}
            staffUserData={staffUserData?.staffUserCurrent as StaffCaseSearchFilterContainerStaffUsersFieldsFragment}
            allTags={caseGetAllTags?.caseGetAllTags as string[]}
            refreshTagHandler={refreshTagHandler}
          />
        }
      />
    </div>
  );
};
